import React from 'react';

// Selector de ubicación del cliente: de mi ciudad (local) o de otra ciudad.
// Si es de otra ciudad, aparece un campo para escribir la ciudad (opcional).
// Reutilizable en el CRM y en los formularios rápidos de cliente.
export default function UbicacionCliente({ esLocal, ciudad, onEsLocal, onCiudad, disabled }) {
  const chip = (activo, colorActivo) => ({
    flex: 1, padding: '8px', borderRadius: '8px', fontSize: '13px', fontWeight: 700, cursor: disabled ? 'not-allowed' : 'pointer',
    border: `1px solid ${activo ? colorActivo : '#E5E7EB'}`,
    backgroundColor: activo ? colorActivo : 'white',
    color: activo ? 'white' : '#6B7280',
  });
  const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };

  return (
    <div>
      <div style={{ display: 'flex', gap: '6px' }}>
        <button type="button" disabled={disabled} onClick={() => onEsLocal(true)} style={chip(esLocal, 'var(--color-primario,#DB2777)')}>
          📍 De mi ciudad
        </button>
        <button type="button" disabled={disabled} onClick={() => onEsLocal(false)} style={chip(!esLocal, '#0EA5E9')}>
          🚚 De otra ciudad
        </button>
      </div>
      {!esLocal && (
        <input value={ciudad || ''} disabled={disabled} onChange={(e) => onCiudad(e.target.value)}
          placeholder="¿De qué ciudad? (ej. San Pedro Sula)" style={{ ...input, marginTop: '6px' }} />
      )}
    </div>
  );
}
